import axios from "axios";
import { getToken } from "../../../auth/authService";

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    Authorization: `Bearer ${getToken()}`,
    "Content-Type": "application/json",
  },
});

/**
 * ===============================
 * ADMIN VOCABULARY SERVICE
 * ===============================
 */

// Dashboard
export const fetchVocabularyDashboard = async () => {
  try {
    const res = await api.get("/admin/vocabulary/dashboard");

    return {
      status: res.status,
      data: res.data,
    };
  } catch (err) {
    return {
      status: err.response?.status || 500,
      data: null,
      message:
        err.response?.data?.message || "Failed to fetch dashboard",
    };
  }
};

// List with filters
export const fetchVocabularyList = async (params) => {
  try {
    const res = await api.get("/admin/vocabulary", { params });

    return {
      status: res.status,
      data: res.data,
    };
  } catch (err) {
    return {
      status: err.response?.status || 500,
      data: null,
      message:
        err.response?.data?.message || "Failed to fetch vocabulary",
    };
  }
};

// Create
export const createVocabulary = async (payload) => {
  try {
    const res = await api.post("/admin/vocabulary", payload);

    return {
      status: res.status,
      data: res.data,
      message: "Vocabulary created successfully",
    };
  } catch (err) {
    return {
      status: err.response?.status || 500,
      message:
        err.response?.data?.message || "Create failed",
    };
  }
};

// Update
export const updateVocabulary = async (id, payload) => {
  try {
    const res = await api.put(`/admin/vocabulary/${id}`, payload);

    return {
      status: res.status,
      data: res.data,
      message: "Updated successfully",
    };
  } catch (err) {
    return {
      status: err.response?.status || 500,
      message:
        err.response?.data?.message || "Update failed",
    };
  }
};

// Delete
export const deleteVocabulary = async (id) => {
  try {
    const res = await api.delete(`/admin/vocabulary/${id}`);

    return {
      status: res.status,
      message: "Deleted successfully",
    };
  } catch (err) {
    return {
      status: err.response?.status || 500,
      message:
        err.response?.data?.message || "Delete failed",
    };
  }
};

// Bulk delete
export const bulkDeleteVocabulary = async (ids) => {
  try {
    const res = await api.delete("/admin/vocabulary/bulk", {
      data: { ids },
    });

    return {
      status: res.status,
      data: res.data,
    };
  } catch (err) {
    return {
      status: err.response?.status || 500,
      message:
        err.response?.data?.message || "Bulk delete failed",
    };
  }
};
